import type { AccountResponse } from '@ltvco/refresh-lib/v1';

// We can't seed the member-perks setting at sign-up on the backend, so I use
// join_date to tell new sign-ups from existing users. Update this to our real
// launch timestamp before release.
const MEMBER_PERKS_LAUNCH_DATE = new Date('2026-06-10T00:00:00Z');

export function isEligibleForMemberPerks(
  account?: AccountResponse | null,
): boolean {
  const joinDate = account?.account.user_info.join_date;
  const signedUpAfterLaunch =
    !!joinDate &&
    new Date(joinDate).getTime() >= MEMBER_PERKS_LAUNCH_DATE.getTime();

  const isDismissed =
    (
      account?.account.user_settings as {
        hide_addept_io_member_perks_page?: boolean | null;
      }
    )?.hide_addept_io_member_perks_page === true;

  return signedUpAfterLaunch && !isDismissed;
}
